import { ButtonGroup } from "@mui/material";
import React from "react";
import { ButtonGroupModel } from "../../Models/ButtonGroupModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

export type ButtonGroupComponentProps = IComponentProps<ButtonGroupModel>;

const ButtonGroupComponent: React.FC<ButtonGroupComponentProps> = ({ component, context }) => {
  const componentLayoutSx = getComponentLayout(component);

  return (
    <ButtonGroup sx={componentLayoutSx} variant={component.Variant} size={component.Size} color={component.Color}>
      {component.Children.map((child) => (
        <ComponentFactory key={child.Id} parent={component} component={child} context={context} />
      ))}
    </ButtonGroup>
  );
};

export default ButtonGroupComponent;
